import { createSnapshotConsumer } from '@highlight/ipc'
import { useSnapshotConsumer } from '@highlight/ipc/react'
import * as Sentry from '@sentry/electron/renderer'
import {
  EMPTY_SPEAKER_RESOLVER_EVIDENCE_SNAPSHOT,
  SPEAKER_RESOLVER_EVIDENCE_TOPIC,
  type SpeakerResolverEvidenceSnapshot,
} from '@shared/speaker-resolver-evidence'

const consumer = createSnapshotConsumer<SpeakerResolverEvidenceSnapshot>({
  topic: SPEAKER_RESOLVER_EVIDENCE_TOPIC,
  initialSnapshot: EMPTY_SPEAKER_RESOLVER_EVIDENCE_SNAPSHOT,
  onError: (error) => {
    Sentry.captureException(error)
  },
})

export function useSpeakerResolverEvidence(): SpeakerResolverEvidenceSnapshot {
  return useSnapshotConsumer(consumer)
}
